export default defineNuxtPlugin((nuxtApp) => {
  const translate = (key: string, ...args) => {
    const $i18n = nuxtApp.$i18n

    return $i18n.t(key, ...args)
  }

  nuxtApp.provide('t', translate)
})
